var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-icon"},[_c('router-link',{staticClass:"h-icon",attrs:{"to":{name: 'offerConf'}}},[_c('book-icon',{attrs:{"title":"Bieżąca oferta"}}),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.productsList.length))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb778b32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/redbay-b2b-offer/src/OfferIcon.vue
// module id = null
// module chunks = 